
define('text!modules/strategy/supply/shared/templates/bin_title.html',[],function () { return '<div class="header-c title" data-bind="{{bin_kind}}-count">Supply Sources:</div>\n';});

